<script setup lang="ts">
import type { Component } from 'vue'
import CompassIcon from '@/components/icons/CompassIcon.vue'
import {
  Activity,
  AudioLines,
  Bell,
  Bot,
  Boxes,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleAlert,
  CircleUserRound,
  Clock3,
  CloudUpload,
  Command,
  Database,
  Ellipsis,
  Eye,
  FileClock,
  FileStack,
  Filter,
  Gauge,
  Headphones,
  HeartPulse,
  KeyRound,
  Laptop,
  LayoutDashboard,
  LibraryBig,
  ListFilter,
  LocateFixed,
  LockKeyhole,
  LogOut,
  Map,
  MapPin,
  Menu,
  MessageCircleMore,
  Moon,
  MoreHorizontal,
  Network,
  PackageCheck,
  PanelLeftClose,
  PanelLeftOpen,
  Pause,
  Pencil,
  Play,
  Plus,
  RadioTower,
  RefreshCw,
  Route,
  Search,
  Send,
  Settings2,
  ShieldCheck,
  Signal,
  SlidersHorizontal,
  Sparkles,
  SquareTerminal,
  Sun,
  Tag,
  TerminalSquare,
  TestTubeDiagonal,
  UploadCloud,
  UserRoundCog,
  UsersRound,
  WandSparkles,
  Wifi,
  X,
  Zap,
} from 'lucide-vue-next'

const props = withDefaults(defineProps<{ name: string; size?: number; strokeWidth?: number }>(), {
  size: 18,
  strokeWidth: 1.8,
})

const icons: Record<string, Component> = {
  activity: Activity,
  audio: AudioLines,
  bell: Bell,
  bot: Bot,
  boxes: Boxes,
  check: Check,
  success: CheckCircle2,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  alert: CircleAlert,
  user: CircleUserRound,
  clock: Clock3,
  upload: CloudUpload,
  command: Command,
  compass: CompassIcon,
  database: Database,
  ellipsis: Ellipsis,
  eye: Eye,
  history: FileClock,
  files: FileStack,
  filter: Filter,
  gauge: Gauge,
  headphones: Headphones,
  health: HeartPulse,
  key: KeyRound,
  laptop: Laptop,
  dashboard: LayoutDashboard,
  library: LibraryBig,
  'list-filter': ListFilter,
  locate: LocateFixed,
  lock: LockKeyhole,
  logout: LogOut,
  map: Map,
  pin: MapPin,
  menu: Menu,
  message: MessageCircleMore,
  moon: Moon,
  more: MoreHorizontal,
  network: Network,
  package: PackageCheck,
  'panel-close': PanelLeftClose,
  'panel-open': PanelLeftOpen,
  pause: Pause,
  edit: Pencil,
  play: Play,
  plus: Plus,
  radio: RadioTower,
  refresh: RefreshCw,
  route: Route,
  search: Search,
  send: Send,
  settings: Settings2,
  shield: ShieldCheck,
  signal: Signal,
  sliders: SlidersHorizontal,
  sparkles: Sparkles,
  terminal: SquareTerminal,
  sun: Sun,
  tag: Tag,
  terminal2: TerminalSquare,
  test: TestTubeDiagonal,
  upload2: UploadCloud,
  'user-cog': UserRoundCog,
  users: UsersRound,
  wand: WandSparkles,
  wifi: Wifi,
  close: X,
  zap: Zap,
}
</script>

<template>
  <component
    :is="icons[props.name] ?? CompassIcon"
    :size="props.size"
    :stroke-width="props.strokeWidth"
    aria-hidden="true"
    focusable="false"
  />
</template>
